import React from 'react'

function LoginButton({className = "", type = "submit", content}) {
  return (
    <button className={className} type={type}>{content}</button>
  )
}

export default LoginButton